import { Select } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.js';
import { FilterTableFieldName } from './types.js';

export function BooleanSelect({ name }: { name: FilterTableFieldName }) {
  const { control } = useFormContext();
  return (
    <Td colSpan={2} type="editable">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => {
          return (
            <Select
              id={name}
              options={[
                {
                  label: 'Yes',
                  value: 'true',
                },
                {
                  label: 'No',
                  value: 'false',
                },
              ]}
              size="sm"
              border={false}
              radius={false}
              isInvalid={fieldState.invalid}
              {...field}
              onChange={(value) => {
                if (value === 'true') {
                  field.onChange(true);
                } else if (value === 'false') {
                  field.onChange(false);
                } else {
                  field.onChange('');
                }
              }}
              placeholder=" "
            />
          );
        }}
      />
    </Td>
  );
}
